import { render, staticRenderFns } from "./VuePassword.vue?vue&type=template&id=18921ff2&scoped=true&"
import script from "./VuePassword.vue?vue&type=script&lang=js&"
export * from "./VuePassword.vue?vue&type=script&lang=js&"
import style0 from "./VuePassword.vue?vue&type=style&index=0&id=18921ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18921ff2",
  null
  
)

export default component.exports